import React from 'react';
import {connect} from "react-redux";
import Countries from 'country-list';
import ViewHeader from '../view-header';
import { updateProfile, resetUpdated } from "./actions";
import Edit from '../../../../components/Profile/edit';
import EditEmail from '../../../../components/Profile/editEmail';
import EditPassword from '../../../../components/Profile/editPassword';
import Notice from "../../../../components/Notification/newNotification";
import ModalComponent from "../../../../components/Modal";

import { validateWebsite, validateEmail } from './heplers';

class Profile extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            errors: {
                title: 'Something went wrong.',
                message: 'Please try again later.',
                level: 'error',
                show: undefined
            },
            countries: Countries().getNames(),
            showEdit: false,
            showEditEmail: false,
            showEditPassword: false,
            user: {
                ...this.props.auth.currentUser,
                oldPassword: '',
                newPassword: '',
                rePassword: ''
            },
            validationErrors: {
                email: {status: false, message: ''},
                password: {status: false, message: ''},
                rePassword: {status: false, message: ''},
                oldPassword: {status: false, message: ''},
                business_email: {status: false, message: ''},
                business_name: {status: false, message: ''},
                business_phone: {status: false, message: ''},
                city: {status: false, message: ''},
                country: {status: false, message: ''},
                first_name: {status: false, message: ''},
                last_name: {status: false, message: ''},
                street_address: {status: false, message: ''},
                username: {status: false, message: ''},
                website: {status: false, message: ''},
                license: {status: false, message: ''},
                zip_code: {status: false, message: ''},

            },
            confirmButtons: {
                email: false,
                password: false,
                fields: false
            }
        }
    }

    componentDidMount () {
        document.title = "My Profile";
    }

    validateInputFields (key, value) {
        if (!['email', 'password', 'oldPassword', 'newPassword', 'website'].includes(key)) {
            const object = (value.trim() === '') ? {status: true, message: `This field is required!`} : {status: false, message: ''}
            this.setState({
                validationErrors: {
                    ...this.state.validationErrors,
                    [key]: object
                }
            })
        }
    }

    showEdit (field = '') {
        Object.assign(this.state.user, this.props.auth.currentUser)
        for (let i in this.state.validationErrors) {
            if (!['email', 'password', 'oldPassword', 'newPassword', 'website'].includes(i)) {
                let object = {}
                object[i] = {status: false, message: ``}
                Object.assign(this.state.validationErrors, object)
                this.setState({confirmButtons: {fields: false}})
            }
        }

        if (field === 'password') {
            Object.assign(this.state.user, { oldPassword: '', newPassword: '',rePassword: ''})
            Object.assign(this.state.validationErrors, {password: {status: false, message: ''}})
            Object.assign(this.state.validationErrors, {oldPassword: {status: false, message: ''}})
            this.setState({confirmButtons: {password: false}})
            this.setState({
                showEdit: false,
                showEditPassword: !this.state.showEditPassword,
                showEditEmail: false
            })
        } else if (field === 'email') {
            Object.assign(this.state.user, this.props.auth.currentUser)
            Object.assign(this.state.validationErrors, {email: {status: false, message: ''}})
            this.setState({confirmButtons: {email: false}})
            this.setState({
                showEdit: false,
                showEditPassword: false,
                showEditEmail: !this.state.showEditEmail
            });
        } else {
            this.setState({
                showEdit: !this.state.showEdit,
                showEditEmail: false,
                showEditPassword: false
            });
        }
    }

    validation (key, value) {
        this.validateInputFields (key, value);
        if (key === 'email') {
            if (validateEmail(value)) {
                Object.assign(this.state.validationErrors, {email: {status: false, message: ''}})
                this.setState({confirmButtons: {email: true}})
            } else {
                Object.assign(this.state.validationErrors, {email: {status: true, message: 'Please enter a valid email.'}})
                this.setState({confirmButtons: {email: false}})
            }
        }

        if (key === 'business_email') {
            if (validateEmail(value)) {
                Object.assign(this.state.validationErrors, {business_email: {status: false, message: ''}})
                this.setState({confirmButtons: {fields: true}})
            } else {
                Object.assign(this.state.validationErrors, {business_email: {status: true, message: 'Please enter a valid email.'}})
                this.setState({confirmButtons: {fields: false}, validationErrors : {...this.state.validationErrors, business_email: {status: true, message: 'Please enter a valid email.'}}})
            }
        }

        if (key === 'oldPassword') {
            if ((value.length >= 6 && value.trim() !== '')) {
                Object.assign(this.state.validationErrors, {oldPassword: {status: false, message: ''}})
                if ((this.state.user.rePassword === this.state.user.newPassword && this.state.user.newPassword.length >= 6) && value.trim() !== '') {
                    this.setState({confirmButtons: {password: true}})
                }
            } else {
                Object.assign(this.state.validationErrors, {oldPassword: {status: true, message: 'Password must be at least 6 character.'}})
                this.setState({confirmButtons: {password: false}})
                return
            }
        } else if (key === 'newPassword') {
            if (value.trim() !== '' && this.state.user.newPassword.length >= 6) {
                Object.assign(this.state.validationErrors, {password: {status: false, message: ''}})
                if (this.state.user.newPassword === this.state.user.rePassword) {
                    this.setState({confirmButtons: { ...this.state.confirmButtons, password: true }})
                }
            } else {
                this.setState({
                    validationErrors: {
                        ...this.state.validationErrors,
                        password: {
                            status: true,
                            message: 'Password must be at least 6 character.'
                        }
                    },
                    confirmButtons: { ...this.state.confirmButtons, password: false }
                });
            }
        } else if (key === 'rePassword') {
            let message = '';
            let status = false;
            let confirmButtons = true;
            if (this.state.user.newPassword !== this.state.user.rePassword) {
                message = 'Your passwords do not match. Please try again.';
                status = true;
                confirmButtons = false
            }
            this.setState({
                validationErrors: {
                    ...this.state.validationErrors,
                    rePassword: { status: status, message: message }
                },
                confirmButtons: { ...this.state.confirmButtons, password: confirmButtons }
            });

        } else if(key === 'website') {
            let message = '';
            let status = !validateWebsite(value);
            if(status) {
                message = 'Please enter a valid url.';
            } else {
                message = '';
            }
            this.setState({
                validationErrors: {
                    ...this.state.validationErrors,
                    website: { status: status, message: message }
                }
            });
        }
    }

    handleChange = (key, value) => {
        const {user} = this.state
        user[key] = value
        this.setState({user})
        this.validation(key, value)
    }

    closeButton = (close) => {
        let button = {}
        button[close] = false
        this.setState(button)
    }

    handleUpdate = (e, updateField = '') => {
        e.preventDefault();
        if(!updateField){
            this.props.updateProfile({...this.state.user, updateField})
        } else {
            const {oldPassword, newPassword, rePassword} = this.state.user;
            let isValid = true;
            let {validationErrors} = this.state
            if (oldPassword.length === 0) {
                isValid = false;
                validationErrors = {
                    ...validationErrors,
                    oldPassword: {
                        status: true,
                        message: 'Old password field is required.'
                    }
                }
            } else if (validationErrors.oldPassword.status) {
                isValid = false;
            }
            if (newPassword.length === 0) {
                isValid = false;
                validationErrors = {
                    ...validationErrors,
                    password: {
                        status: true,
                        message: 'New password field is required.'
                    }
                }
            }
            if (validationErrors.password.status) {
                isValid = false;
            }
            if (rePassword.length === 0) {
                isValid = false;
                validationErrors = {
                    ...validationErrors,
                    rePassword: {
                        status: true,
                        message: 'Confirm password field is required.'
                    }
                }
            }
            if (validationErrors.rePassword.status) {
                isValid = false;
            }
            if (isValid) {
                this.props.updateProfile({...this.state.user, updateField})
            } else {
                this.setState({validationErrors})
            }
        }
    }

    handleUpdateEmail = (e) => {
        e.preventDefault();
        const { email } = this.state.user;
        if (email.length === 0 ) {
            this.setState({validationErrors: {
                    ...this.state.validationErrors,
                    email: {
                        status:true,
                        message:'Email field is required.'
                    }
                }})
        } else if(!this.state.validationErrors.email.status){
            this.props.updateProfile({...this.state.user, updateField:'email'})
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.profile.error) {
            this.setState({
                validationErrors: {
                    ...this.state.validationErrors,
                    oldPassword: {
                        ...this.state.validationErrors.oldPassword,
                        message: nextProps.profile.error
                    }
                }
            })
        }
        if (nextProps.profile.emailExistsError === false) {
            Notice.addNotification('Profile was successfully updated.', "success");
            this.setState({
                showEdit: false,
                showEditPassword: false,
                showEditEmail: false
            }, () => this.props.resetUpdated())
        } else if (nextProps.profile.emailExistsError === true) {
            Notice.addNotification(nextProps.profile.error, "error");
            this.setState({
                showEdit: false,
                showEditEmail: false
            }, () => this.props.resetUpdated())
        }
    }


    render () {
        let header = 'My Profile';
        let desc = 'My personal account';
        return (
            <div className="view">
                <div className="view-content">
                    <div className="user-block">
                        <div className="my-profile">
                            <div className="my-profile__title">
                                <button
                                    className="back-to"
                                    data-toggle="tooltip"
                                    onClick={() => this.props.history.goBack()}
                                >
                                    <span className="kr kr-arrow"/>
                                </button>
                                <h2>My profile</h2>
                            </div>
                            <div className="my-profile__block">
                                <div className="info">
                                    <span className="kr kr-edit" onClick={() => this.showEdit()}/>
                                    <div className="info__box">
                                        <h6>Personal information</h6>
                                        <div className="info__item">
                                            <span>First Name</span>
                                            <span>{this.props.auth.currentUser.first_name}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Last Name</span>
                                            <span>{this.props.auth.currentUser.last_name}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Username</span>
                                            <span>{this.props.auth.currentUser.username}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Email</span>
                                            <span>{this.props.auth.currentUser.email}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Status</span>
                                            <span>{this.props.auth.currentUser.status}</span>
                                        </div>
                                        <div className="edit-actions">
                                            <button
                                                className="btn btn-link"
                                                onClick={() => this.showEdit('password')}
                                            >
                                                Change Password
                                            </button>
                                            <button
                                                className="btn btn-link"
                                                onClick={() => this.showEdit('email')}
                                            >
                                                Change Email
                                            </button>
                                        </div>
                                    </div>
                                    <div className="info__box">
                                        <h6>Business information</h6>
                                        <div className="info__item">
                                            <span>Business Name</span>
                                            <span>{this.props.auth.currentUser.business_name}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Business Email Address</span>
                                            <span>{this.props.auth.currentUser.business_email}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Business Phone Number</span>
                                            <span>{this.props.auth.currentUser.business_phone}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Country</span>
                                            <span>{this.props.auth.currentUser.country}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>City</span>
                                            <span>{this.props.auth.currentUser.city}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Postal Code/Zip</span>
                                            <span>{this.props.auth.currentUser.zip_code}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Street Address</span>
                                            <span>{this.props.auth.currentUser.street_address}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>License</span>
                                            <span>{this.props.auth.currentUser.license}</span>
                                        </div>
                                        <div className="info__item">
                                            <span>Website</span>
                                            <a target="_blank" href={this.props.auth.currentUser.website}>{this.props.auth.currentUser.website}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        {(this.state.showEdit) &&
                        <ModalComponent
                            dialogClassName="edit__profile profile__modals"
                            modalHeaderStyle="modalHeaderDefault"
                            headerTitle="Edit Profile"
                            isAdmin={false}
                            modalBody={
                                <Edit
                                    closeButton={this.closeButton}
                                    message={this.state.message}
                                    handleChange={this.handleChange}
                                    countries={this.state.countries}
                                    confirmButtons={this.state.confirmButtons}
                                    validationErrors={this.state.validationErrors}
                                    user={this.state.user}
                                />
                            }
                            show={this.state.showEdit}
                            handleClose={() => this.closeButton('showEdit')}
                            buttonText="Save"
                            buttonFunction={this.handleUpdate}
                        />
                        }
                        {(this.state.showEditEmail) &&
                        <ModalComponent
                            dialogClassName="profile__modals"
                            modalHeaderStyle="modalHeaderDefault"
                            headerTitle="Edit Email Address"
                            isAdmin={false}
                            modalBody={
                                <EditEmail
                                    closeButton={this.closeButton}
                                    handleChange={this.handleChange}
                                    handleUpdate={this.handleUpdateEmail}
                                    confirmButtons={this.state.confirmButtons}
                                    validationErrors={this.state.validationErrors}
                                    user={this.state.user}
                                />
                            }
                            show={this.state.showEditEmail}
                            handleClose={() => this.closeButton('showEditEmail')}
                            buttonText="Save"
                            buttonFunction={(e) => this.handleUpdateEmail(e,'email')}
                        />
                        }
                        {(this.state.showEditPassword) &&
                        <ModalComponent
                            dialogClassName="profile__modals"
                            modalHeaderStyle="modalHeaderDefault"
                            headerTitle="Change Password"
                            isAdmin={false}
                            modalBody={
                                <EditPassword
                                    closeButton={this.closeButton}
                                    handleChange={this.handleChange}
                                    handleUpdate={this.handleUpdate}
                                    confirmButtons={this.state.confirmButtons}
                                    validationErrors={this.state.validationErrors}
                                    user={this.state.user}
                                />
                            }
                            show={this.state.showEditPassword}
                            handleClose={() => this.closeButton('showEditPassword')}
                            buttonText="Save"
                            buttonFunction={(e) => this.handleUpdate(e, 'password')}
                        />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    profile: state.profile,
    auth: state.auth
});

const mapDispatchToProps = dispatch => {
    return {
        updateProfile: (data) => { dispatch(updateProfile(data)); },
        resetUpdated: () => { dispatch(resetUpdated()); }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Profile/index.js